import React from 'react';

export default function SectionContainer({
  backgroundColor,
  className,
  children,
}) {
  return (
    <div
      className={`section-container ${backgroundColor || 'gray'}${
        className ? ` ${className}` : ''
      }`}
    >
      {children}
    </div>
  );
}
